import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

import banner1 from "../../Assets/Images/banner1.webp";
import banner2 from "../../Assets/Images/banner2.webp";
import banner3 from "../../Assets/Images/banner3.webp";
import banner4 from "../../Assets/Images/banner4.webp";
import banner5 from "../../Assets/Images/banner5.webp";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const Banner = () => {
    return (
        <>

            <div className="homeBanner d-flex justify-content-start align-items-center">

                <div className="contanier-fluid mx-5 px-5 text-light ">
                    <h2 className='fw-semibold'>
                        Make Money online with
                    </h2>

                    <h1 className='fw-bold'>
                        Popgop Affiliates
                    </h1>
                    <h2 className='fw-semibold'>
                        Promote anything listed on Popgop
                    </h2>

                    <h3 >
                        More than 500,000 products to choose from
                    </h3>

                    <div className="d-flex">
                        <Button as={Link} to={"/login"} variant='success' className="px-5 py-2" >
                            Sign Up Now
                        </Button>
                    </div>

                </div>

                {/* <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    // navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    // scrollbar={{ draggable: true }}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}
                >
                    <SwiperSlide>
                        <img src={banner1} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner2} width={"100%"} alt="" />

                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner3} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner4} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner5} width={"100%"} alt="" />
                    </SwiperSlide>
                </Swiper> */}
            </div>

        </>
    )
}

export default Banner